
/**
 * Export `finishes`.
 */

export const finishes = {
  antislipNat: 'antislipNat',
  antislipRect: 'antislipRect',
  estrNat: 'estrNat',
  estrRect: 'estrRect',
  lapped: 'lapped',
  mattNat: 'mattNat',
  mattRect: 'mattRect',
  natural: 'natural',
  polished: 'polished',
  rectified: 'rectified',
  silk: 'silk',
  soft: 'soft',
  softGrip: 'softGrip'
};

/**
 * Export `finishesValues`.
 */

export const finishesValues = {
  [finishes.antislipNat]: 'antislip nat',
  [finishes.antislipRect]: 'antislip rect',
  [finishes.estrNat]: 'estr nat',
  [finishes.estrRect]: 'estr rect',
  [finishes.lapped]: 'lapped',
  [finishes.mattNat]: 'matt nat',
  [finishes.mattRect]: 'matt rect',
  [finishes.natural]: 'natural',
  [finishes.polished]: 'polished',
  [finishes.rectified]: 'rectified',
  [finishes.silk]: 'silk',
  [finishes.soft]: 'soft',
  [finishes.softGrip]: 'soft grip'
} as const;

/**
 * Export `finishesIconsLarge`.
 */

export const finishesIconsLarge = {
  [finishes.antislipNat]: require('src/assets/svg/finish/antislip-nat.svg'),
  [finishes.antislipRect]: require('src/assets/svg/finish/antislip-rect.svg'),
  [finishes.estrNat]: require('src/assets/svg/finish/estr-nat.svg'),
  [finishes.estrRect]: require('src/assets/svg/finish/estr-rect.svg'),
  [finishes.lapped]: require('src/assets/svg/finish/lap.svg'),
  [finishes.mattNat]: require('src/assets/svg/finish/matt-nat.svg'),
  [finishes.mattRect]: require('src/assets/svg/finish/matt-rect.svg'),
  [finishes.natural]: require('src/assets/svg/finish/nat.svg'),
  [finishes.polished]: require('src/assets/svg/finish/pol.svg'),
  [finishes.rectified]: require('src/assets/svg/finish/rect.svg'),
  [finishes.silk]: require('src/assets/svg/finish/silk.svg'),
  [finishes.soft]: require('src/assets/svg/finish/soft.svg'),
  [finishes.softGrip]: require('src/assets/svg/finish/soft-grip.svg')
};

/**
 * Export `finishesIconsSmall`.
 */

export const finishesIconsSmall = {
  [finishes.antislipNat]: require('src/assets/svg/finish/antislip-nat-small.svg'),
  [finishes.antislipRect]: require('src/assets/svg/finish/antislip-rect-small.svg'),
  [finishes.estrNat]: require('src/assets/svg/finish/estr-nat-small.svg'),
  [finishes.estrRect]: require('src/assets/svg/finish/estr-rect-small.svg'),
  [finishes.lapped]: require('src/assets/svg/finish/lap-small.svg'),
  [finishes.mattNat]: require('src/assets/svg/finish/matt-nat-small.svg'),
  [finishes.mattRect]: require('src/assets/svg/finish/matt-rect-small.svg'),
  [finishes.natural]: require('src/assets/svg/finish/nat-small.svg'),
  [finishes.polished]: require('src/assets/svg/finish/pol-small.svg'),
  [finishes.rectified]: require('src/assets/svg/finish/rect-small.svg'),
  [finishes.silk]: require('src/assets/svg/finish/silk-small.svg'),
  [finishes.soft]: require('src/assets/svg/finish/soft-small.svg'),
  [finishes.softGrip]: require('src/assets/svg/finish/soft-grip-small.svg')
};
